import { FormNameOptions } from '../enums/FormNameOptions';

function getFormName(): FormNameOptions {
  return FormNameOptions.TAX_REFERRAL_FORM;
}

export { getFormName };
